module.exports = __webpack_public_path__ + "static/img/usercenter_certificate.be810f18.png";